export const RsvpStatusIdEnum = {
    NotResponded: 1,
    Yes: 2,
    No : 3
}